import type { ErroApi } from "@horofacial/shared";

export class ErroRequisicao extends Error {
  constructor(
    readonly status: number,
    readonly corpo: ErroApi,
  ) {
    super(corpo.mensagem);
  }
}

export async function api<T>(caminho: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, headers, ...resto } = init;
  let resposta: Response;
  try {
    resposta = await fetch(`/api${caminho}`, {
      ...resto,
      credentials: "same-origin",
      headers: { ...(json !== undefined ? { "content-type": "application/json" } : {}), ...headers },
      body: json !== undefined ? JSON.stringify(json) : init.body,
    });
  } catch {
    // Sem resposta (sem internet, servidor fora do ar): no lugar do "Failed to fetch" do navegador.
    throw new ErroRequisicao(0, { erro: "rede", mensagem: "Sem conexão com o servidor. Confira a internet e tente de novo." });
  }

  if (!resposta.ok) {
    const corpo = (await resposta.json().catch(() => null)) as ErroApi | null;
    throw new ErroRequisicao(
      resposta.status,
      corpo ?? { erro: "rede", mensagem: `Falha na comunicação com o servidor (${resposta.status})` },
    );
  }
  if (resposta.status === 204) return undefined as T;
  return (await resposta.json()) as T;
}
